import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ChestItem from '@/roc/effects/Production/ChestItem';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const BasketDryingRack = {
  id: '88',
  name: 'Basket Drying Rack',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Basket_Drying_Rack',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Basket_Drying_Rack',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(5),
      [
        ProductionCost.asPerLevel([
          350, 346, 343, 339, 336, 333, 330, 327, 324, 321,
          318, 315, 312, 309, 307, 304, 301, 299, 296, 294,
          291, 289, 286, 284, 282, 280, 277, 275, 273, 271,
          269, 267, 265, 263, 261, 259, 257, 255, 253, 251,
        ]).withCurrency(ProductionCurrency.CURRENT_ERA_TERTIARY_GOODS),
      ],
      ProductionDuration.asCallbackWithLevel(
        (level) => {
          return 24 * 60 * 60 - ((level - 1) * 15 * 60);
        }
      ),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST).withItems([
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(2).withChance(12.5).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(25).withChance(12.5).withOutput(ProductionOutputType.GEARS),
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.RANDOM_BARRACKS_REFILL),
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.NEGOTIATION_JOKER),
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.RANDOM_MERCENARY_COMMANDER),
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.EVENT_PUZZLE_PIECE),
        ChestItem.asFlat(1).withChance(12.5).withOutput(ProductionOutputType.SQUAD_HEALING_ITEM),
      ])
    ),
  ]),
};

export default BasketDryingRack;
